"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
/**
 * @param {{
 *     emailDomain: string;
 * }} props
 */
function DataProcessing(_ref) {
  var emailDomain = _ref.emailDomain;
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: "tratamento-de-dados"
  }, /*#__PURE__*/_react["default"].createElement("h4", null, /*#__PURE__*/_react["default"].createElement("strong", null, "4. DO RESPONS\xC1VEL PELO TRATAMENTO DOS DADOS:")), /*#__PURE__*/_react["default"].createElement("p", null, "Para saber mais sobre o tratamento dos dados pessoais, o", /*#__PURE__*/_react["default"].createElement("strong", null, " USU\xC1RIO "), "ou terceiro interessado poder\xE1 contatar a empresa atrav\xE9s do e-mail: dpo@", emailDomain, "."));
}
var _default = DataProcessing;
exports["default"] = _default;